import { useEffect, useState } from "react";
import { useTournamentContext } from "../../../../hook/context";
import * as S from "./styles";
import * as C from "../../style";
import ImageDropzone from "../../../../../../component/ImageDropZone";
import { ImageDropInitialContent } from "../../../../../reservation/styles/createReservationPopup";

export const EditTournamentReservation = () => {
  const {
    isReservation,
    setIsReservation,
    reservationImage,
    setReservationImage,
  } = useTournamentContext();
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  useEffect(() => {
    if (reservationImage) {
      if (typeof reservationImage === "string") {
        setPreviewUrl(reservationImage);
      } else if (reservationImage instanceof File) {
        const url = URL.createObjectURL(reservationImage);
        setPreviewUrl(url);
        return () => {
          URL.revokeObjectURL(url);
        };
      }
    } else {
      setPreviewUrl(null);
    }
  }, [reservationImage]);
  return (
    <S.EditTournamentReservationWrapper>
      <S.EditTournamentReservationTop>
        <div className="name">예약 생성</div>
        <C.EditTournamentCheckBox>
          <input
            type="checkbox"
            checked={isReservation}
            onChange={(e) => setIsReservation(e.target.checked)}
          />
          {isReservation && (
            <img src="/image-web/tournament/checked-icon.svg" alt="checked" />
          )}
        </C.EditTournamentCheckBox>
      </S.EditTournamentReservationTop>
      {isReservation && (
        <S.EditTournamentReservationInputBox>
          <div className="name">예약 이미지</div>
          <S.EditTournamentReservationInputContent>
            <ImageDropzone
              onImageUpload={setReservationImage}
              defaultUrl={previewUrl || ""}
            >
              <ImageDropInitialContent>
                <img src="/image-web/icon/image.svg" alt="Initial content" />
                <h2>포스터 이미지를 올려주세요!</h2>
                <p>최소 400px * 400px,</p>
                <p>최대 1600px * 1600px로 설정할 수 있습니다.</p>
              </ImageDropInitialContent>
            </ImageDropzone>
          </S.EditTournamentReservationInputContent>
        </S.EditTournamentReservationInputBox>
      )}
    </S.EditTournamentReservationWrapper>
  );
};
